import { Services } from '@sigma-frontend-libs/commons'
import { EReportTaskRecurrentStatus } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    /**
     * Значения полей фильтра в меню кнопки фильтра по умолчанию для кнопки сброса.
     *
     * @returns {Object<string, undefined>} Пустое значение по имени поля.
     */
    defaultFilter() {
      return {
        name: undefined,
        type: undefined,
        status: undefined,
        ownerId: undefined
      }
    },

    statuses() {
      return Object.values(EReportTaskRecurrentStatus).map(item => {
        return {
          title: this.getTranslate(`${Services['report-manager']}.statuses.${item}`),
          value: item
        }
      })
    }
  },

  render
}
